import * as constants from './constants';
import { fromJS } from 'immutable';
import config from "../../../config";

const defaultState = fromJS({
	builds: fromJS({
		'list': [],
		"total": 0,
		"page": 1,
		"perpage": config.perpage,
	})
});

const stateAction = (state = defaultState, action) => {
	switch(action.type) {
		case constants.CHANGE_BUILDS:
			console.log('action.builds: ', action.builds);
			return state.merge({builds: fromJS(action.builds)});
		default:
			return state;
	}
}

export default stateAction;